
import Marionette from "../../shared/marionette-mustache";
import {autoinject, Container} from "aurelia-dependency-injection";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {AppEvents} from "../../app-events";
import {ImportModel} from "../models/Import";
import {IRequestOptions} from "../../search/interfaces/request-options";
import {ReportStatusCollection} from "../collections/report-status";
import {FileStatuses} from "./file-statuses";
import {ReportStatuses} from "../views/report-statuses";
import {prop} from "../../decorators/property";

const template = require<string>("./import.html");
require("../styles/import.less");

const dom = {
    IMPORT_STATUS_REGION: "#import-status-region",
    REPORT_STATUS_REGION: ".report-status-region",
    FILE_STATUS_REGION: ".file-status-region"
};

@backboneViewProperties({
    template: template
})
@autoinject
export class ImportView extends Marionette.LayoutView<ImportModel> {

    private reportStatusRegion: Marionette.Region;
    private fileStatusRegion: Marionette.Region;

    constructor(
        private appEvents: Backbone.Events,
        public model: ImportModel) {
        super({model : model});
        this.$el = $(this.el);
        this.listenTo(this.model, "add: FileStatuses", this.render);
        this.listenTo(this.model, "change: FileStatuses", this.render);
    }

    public events(): Backbone.EventsHash {
        const ev: Backbone.EventsHash = {
            "click .report-status-row": (e) => this.reportClicked(e),
        };
        return ev;
    }
    public reportClicked(e: JQueryEventObject) {
        const $report = e.currentTarget;
        // e.currentTarget
        const source = $($report).data("source");
        this.model.load(source);
        $(".file-status-region").scrollTop(0);
    }
    public onShow() {
        $(dom.IMPORT_STATUS_REGION).removeClass("vanish");
        this.setupSubViews();
    }

    private setupSubViews() {
        try {
            const reportStatuses = new ReportStatuses({collection: this.model.ReportStatuses});
            this.reportStatusRegion = this.addRegion("reportStatusRegion", dom.REPORT_STATUS_REGION);
            this.reportStatusRegion.show(reportStatuses);

            const fileStatuses = new FileStatuses({collection: this.model.FileStatuses});
            this.fileStatusRegion = this.addRegion("fileStatusRegion", dom.FILE_STATUS_REGION);
            this.fileStatusRegion.show(fileStatuses);

        } catch (ex) {
            //
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/views/Import.ts